<template>
  <div class="widget-wrapper">
    <iframe
      src="https://discord.com/widget?id=828365516611256361&theme=dark"
      width="350"
      height="500"
      allowtransparency="true"
      frameborder="0"
      sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'DiscordWidget',
};
</script>

<style scoped>
.widget-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 120px;
}
</style>
